<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M14.625 2.95312H3.375C3.11393 2.95313 2.86355 3.05684 2.67894 3.24144C2.49434 3.42605 2.39062 3.67643 2.39062 3.9375V7.875C2.39062 11.527 4.15687 13.7391 5.63906 14.9513C7.23727 16.2591 8.82211 16.7013 8.88891 16.7196C8.96164 16.7395 9.03836 16.7395 9.11109 16.7196C9.17789 16.7013 10.7627 16.2591 12.3609 14.9513C13.8431 13.7391 15.6094 11.527 15.6094 7.875V3.9375C15.6094 3.67643 15.5057 3.42605 15.3211 3.24144C15.1365 3.05684 14.8861 2.95313 14.625 2.95312ZM14.7656 7.875C14.7656 10.53 13.7855 12.6837 11.8519 14.2777C11.0036 14.9742 10.0379 15.5138 9 15.8709C7.962 15.5141 6.99617 14.9745 6.14813 14.2777C4.21453 12.6837 3.23438 10.53 3.23438 7.875V3.9375C3.23438 3.9002 3.24919 3.86444 3.27556 3.83806C3.30194 3.81169 3.3377 3.79688 3.375 3.79688H14.625C14.6623 3.79688 14.6981 3.81169 14.7244 3.83806C14.7508 3.86444 14.7656 3.9002 14.7656 3.9375V7.875ZM12.1106 7.01438C12.1896 7.09348 12.234 7.2007 12.234 7.3125C12.234 7.4243 12.1896 7.53152 12.1106 7.61062L8.17312 11.5481C8.09402 11.6271 7.9868 11.6715 7.875 11.6715C7.7632 11.6715 7.65598 11.6271 7.57688 11.5481L5.88938 9.86063C5.81486 9.78065 5.77429 9.67488 5.77621 9.56558C5.77814 9.45629 5.82242 9.35201 5.89971 9.27471C5.97701 9.19742 6.08129 9.15314 6.19058 9.15121C6.29988 9.14929 6.40565 9.18985 6.48562 9.26437L7.875 10.653L11.5144 7.01438C11.5935 6.93537 11.7007 6.891 11.8125 6.891C11.9243 6.891 12.0315 6.93537 12.1106 7.01438Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'PermissionsIconHollow18'
};
</script>

<style scoped>

</style>